// extracted by mini-css-extract-plugin
export default {"dateContainer":"StatisticsModal_dateContainer__DYSNb","label":"StatisticsModal_label__dgURs"};